export default [
  { title: "e-Materai", icon: "ri-home-4-line", link: "/send-money" },
  { title: "e-Stamp", icon: "ri-wallet-line", link: "/receive-money" },
  { title: "e-Signature", icon: "ri-file-edit-line", link: "/transaction-money" },
];
